import React from "react";
import { Helmet } from "react-helmet";
import { Translation } from "react-i18next";
import  styles from './userDelete.module.scss'
import { asset } from "../../helpers/dom.helper";
import { Redirect } from "react-router";
import _ from 'lodash'

export default class UserDelete extends React.Component {
    
    constructor(props) {
        super(props)
    
        this.state = {
          token : "",
          email : "",
          reason: "",
          explain: "",
          isSuccess: false,
          isError: true,
          redirect:false
        }

         this.onSubmit = this.onSubmit.bind(this);
         this.handleChange = this.handleChange.bind(this);
    
      }

    componentDidMount(){
         this.getData()
    }

    getData() {


      fetch('https://silvermanapp.com/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: `
                query auth ($username: String, $password: String, $role: String, $mobileToken: String) {
                    auth (username: $username, password: $password, role: $role, mobileToken: $mobileToken) {
                        token
                        permission
                        result
                        haveVat
                        message
                    }
                }
                `,
                variables: {
                username: "admin-svm",
                password: "Supportsvm#161123",
                role: "",
                mobileToken: ""
                },
            }),
        })
            .then((res) => res.json())
            .then((result) => {
                this.setState({
                    token : result.data.auth.token
                })
        });
    }

    handleChange(e) {
        let event = _.cloneDeep(e)
        this.setState(prevState => {
            return _.set(
                _.cloneDeep(prevState),
                event.target.name,
                event.target.value
            );
        })
    }

    onSubmit (e) {
        e.preventDefault()
        
        if(this.state.email && this.state.reason && this.state.explain){
            fetch('https://silvermanapp.com/graphql', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `JWT ${this.state.token}`
                },
                body: JSON.stringify({
                    query: ` 
                    mutation emailDelete ($input: EmailDeleteInput!) {
                        emailDelete (input: $input) {
                            ok
                            message
                        }
                    }
                    `,
                    variables: {
                        input : {
                            email: this.state.email,
                            reason: this.state.reason,
                            explain: this.state.explain
                        }
                    },
                }),
            })
            .then((res) => res.json())
            .then((result) => {
                if(result.data.emailDelete.ok){
                    this.setState({
                        isSuccess: true
                    })
                    setTimeout(() => {
                        window.location.reload()
                      }, 3000);
                }else{
                    this.setState({
                        isError: false
                    })
                    setTimeout(() => {
                        window.location.reload()
                      }, 3000);
                }
                
            });
        }
    
    }
    

    render() {
      
       return(
        <Translation ns={['translation', 'user']}>
        {t => (
            <>
              <form id="asset" onSubmit={this.onSubmit}>
                <div className={styles.userDelete}>
                    <div className="text-center">
                        <img src={asset('/icon/user.png')} style={{width:'30%'}}/>
                    </div>
                    <div className="pt-5">
                    <p><strong>{t("user:account deletion")}:</strong> {t("user:accept detail")} </p>
                    </div>
                    <div>
                    <p> <input name="email" type="email" id="email" 
                     placeholder={t("user:email")} onChange={this.handleChange} className="form-control" required /> </p>
                    <p><input type="text" name="reason" placeholder={t("user:reason")} onChange={this.handleChange} className="form-control"  required /></p>
                    <p><textarea type="text" name="explain" placeholder={t("user:description")} onChange={this.handleChange} className="form-control" required /> </p>
                    </div>
                    <div><input type="checkbox" required/> {t("user:accept")}</div>
                    <div className="row">
                    {this.state.isSuccess && (
                        <div className="alert alert-success mt-3" role="alert" style={{margin:'0 auto'}} >
                           {t("user:success")}
                        </div>
                    )}
                     {!this.state.isError  && (
                        <div className="alert alert-warning mt-3" role="alert" style={{margin:'0 auto'}}>
                            {t("user:error")}
                        </div>
                    )}
                    </div>
                    <div className="row pt-4 pb-4">
                        <button type="submit" 
                         className="btn btn-primary userdelete">{t("user:delete account")}</button>
                    </div>
                </div>
           
                </form>

            </>
        )}
        </Translation>
       )
         
    }
}